import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/Done';
import clsx from 'clsx';
import { IRequestCalloutDTO } from '../calloutRequested/types/IRequestCalloutDTOs';
import { Button } from '@material-ui/core';
import CalloutStatuses from '../types/CalloutStatuses';
import {getLabelNameForDirver} from './calloutResponseHelpers'; 

interface CalloutStatusLabelForDriverProps {
    row: IRequestCalloutDTO,
    undoRequestCallout: any,
    isMyVehicle: boolean,
    activeRequestCalloutId: string|null
};

const useStyles = makeStyles({
    container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: 'center'
    },
    iconBox: {
        width: 30,
        height: 30,
        borderRadius: 26,
        zIndex: 2,
    },
    myVehicleIcon:{
        backgroundColor: '#3FA052',
    },
    anotherVehicleIcon:{
        backgroundColor: '#02489D',
    },
    icon: {
        color: "white", 
        fontSize:'1.4rem',
        paddingTop:'3px',
        paddingLeft:'3px',       
    },
    labelText:{
        fontSize: 16, 
        fontWeight: 500,
        fontFamily: 'lato',
        borderRadius: 4, 
        marginLeft: 8, 
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: 140,
        display: "block",
    },
    undo:{
        fontSize: 16, 
        fontWeight: 500,
        fontFamily: 'lato',
        borderRadius: 4, 
        marginLeft: 12,
        color:"#F4B827",
        display: "flex",
    }
});


const CalloutStatusLabelForDriver: React.FC<CalloutStatusLabelForDriverProps> = ({
    row, 
    undoRequestCallout,
    isMyVehicle,
    activeRequestCalloutId}) => {
    const classes = useStyles();
    if(row.status === CalloutStatuses.dispatchedToTeam){
        return null;
    }
    const iconBox = isMyVehicle?clsx(classes.iconBox, classes.myVehicleIcon): clsx(classes.iconBox, classes.anotherVehicleIcon);
    return (
        <div className={classes.container}>
            <span className={iconBox}>
                <DoneIcon className={classes.icon} />
            </span>
            <span className={classes.labelText}>{getLabelNameForDirver(
                (row.status??0),
                isMyVehicle,
                row.assignedVehicle
                )}</span>
            {isMyVehicle && <span>
                <a className={classes.undo}
                    onClick={() => undoRequestCallout(row.requestCalloutId, (row.status??0) - 1)}
                    >
                        Undo
                </a>
            </span>}
        </div>
    );
}

export default CalloutStatusLabelForDriver;
